import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import $ from "jquery";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";

const wishImg = require("./../assets/img/wishlist-icon2.svg").default;
const icon1 = require("./../assets/img/about-icon1.svg").default;
const icon2 = require("./../assets/img/about-icon2.svg").default;
const icon3 = require("./../assets/img/about-icon3.svg").default;
const icon4 = require("./../assets/img/about-icon4.svg").default;
const icon5 = require("./../assets/img/about-icon5.svg").default;
const icon6 = require("./../assets/img/about-icon6.svg").default;
const icon7 = require("./../assets/img/about-icon7.svg").default;
const icon8 = require("./../assets/img/about-icon8.svg").default;

const Imprint = () => {
  const { selectedLanguage, langJson } = useLanguage();
  const slugName = 'imprint';
  const [allDetails, setAllDetails] = useState();

  const fetchCms = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}frontend/cms?slug=${slugName}&lang=${selectedLanguage}`, {
        method: "GET",
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setAllDetails(responseData.data.description);
      }
    } catch (error) {
      console.error("Error fetching imprint:", error);
    }
  };

  useEffect(() => {
    fetchCms();
  }, [selectedLanguage]);

  return (
    <div>
      <Header />
      <style>{`body { background: #FFFFFF; }`}</style>

      <div className="fairDiv">
        <div className="fullContainer">
          <div className="aboutDiv aboutNew termsSec">
            <h2>{langJson?.imprint}</h2>
            <div
              className="cmsContent"
              dangerouslySetInnerHTML={{ __html: allDetails }}
            />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Imprint;
